// 登录后打开哪个页面：取角色配的「默认首页」（角色管理里设置），配的页面打不开就回落到第一个能打开的页面。
// 与后端 resolveHomePath 同一套口径：后端算 key 并随 /api/me 返回，前端负责 key → 路径 + 权限兜底。
import { DEFAULT_HOME, HOME_PAGES, homePageOf } from "@riskops/shared";
import { allowsAny, routePermissions } from "./access";

/** 解析出可用的首页 key（一定是一个当前用户打得开的页面）。 */
export function homeKeyFor(user: unknown): string {
  const configured = String((user as { homePath?: string } | null)?.homePath ?? DEFAULT_HOME);
  const page = homePageOf(configured);
  if (page && allowsAny(user, routePermissions[page.key] ?? page.permission)) return page.key;
  // 回落的第一个"能打开的页面"也跳过已下线的（例如统计报表），免得默认首页落到占位页
  const fallback = HOME_PAGES.find(page => !page.hidden && allowsAny(user, routePermissions[page.key] ?? page.permission));
  return fallback?.key ?? "me";
}

/** 首页 key → 路由路径。 */
export function homePathFor(user: unknown): string {
  const key = homeKeyFor(user);
  return HOME_PAGES.find(page => page.key === key)?.path ?? `/${key}`;
}
